import { useState, useEffect, useContext } from "react";
import { Backdrop, Fab, Button } from "@mui/material";
import { ClickAwayListener } from "@mui/base";
import { useParams } from "react-router-dom";
import Accordion from "./Accordion";
import { developAxios } from "../../axios.config";
import { FormDiv } from "./Form.styled";
import { Close } from "@mui/icons-material";

const ContentDetail = () => {
	const [data, setData] = useState([]);
	// const { courseId } = useContext(AllCourseContext);
	const [displayForm, setDisplayForm] = useState(false);
	const [proDoc, setProDoc] = useState("");
	const [heading, setHeading] = useState("");
	const [foundation, setFoundation] = useState("");
	const [description, setDescription] = useState("");
	const [assignment, setAssignment] = useState("");
	const [test, setTest] = useState("");
	const [name, setName] = useState("");

	const params = useParams();

	useEffect(() => {
		let urlParams = new URLSearchParams(document.location.search);

		let courseId = urlParams.get("course");
		console.log("course id = " + courseId);
		console.log("tech id = " + params._id);
		if (!courseId) {
			return;
		}
		developAxios(localStorage.getItem("token"))
			.get(`/get-learning-data/${courseId ? courseId : ""}`)
			.then(({ data }) => {
				console.log(data.data);
				const [a] = data.data.learning.filter(
					(val) => val._id === params._id
				);
				setHeading(a.heading);
				setData(a.content);
			})
			.catch((err) => console.log(err));
	}, [params._id]);

	function handleSubmit(e) {
		e.preventDefault();
		let urlParams = new URLSearchParams(document.location.search);

		let courseId = urlParams.get("course");
		developAxios(localStorage.getItem("token"))
			.post(
				`/add-content-data/${courseId}`,
				{
					content: {
						prodoc: proDoc,
						description: description,
						foundation: foundation,
						assignment: assignment === "" ? undefined : assignment,
						test: test === "" ? undefined : test,
						name: name,
					},
					heading: heading,
				},

				{
					headers: {
						Authorization: "token",
					},
				}
			)
			.then(({ data }) => {
				alert("Data has been submited");
				// console.log(data);
			})
			.catch((e) => {
				console.log(e);
			});
	}

	// console.log(a.foundation);
	return (
		<div>
			{displayForm && (
				<Backdrop open={true} sx={{ zIndex: 100 }}>
					<ClickAwayListener
						onClickAway={() => setDisplayForm(false)}
					>
						<FormDiv>
							<Fab
								sx={{
									position: "absolute",
									top: "10px",
									right: "10px",
								}}
								onClick={() => setDisplayForm(false)}
							>
								<Close />
							</Fab>
							<div className="container">
								<form id="contact" onSubmit={handleSubmit}>
									<h3>Upload Content</h3>
									<label>Foundation</label>
									<fieldset>
										<input
											placeholder="Foundation"
											name="Foundation"
											value={foundation}
											onChange={(e) =>
												setFoundation(e.target.value)
											}
											type="text"
											tabindex="3"
											required
										/>
									</fieldset>
									<label>ProDoc</label>
									<fieldset>
										<input
											placeholder="ProDoc"
											name="prodoc"
											value={proDoc}
											onChange={(e) =>
												setProDoc(e.target.value)
											}
											type="text"
											tabindex="3"
											required
										/>
									</fieldset>
									<label>Assignment</label>
									<fieldset>
										<input
											placeholder="Assignment"
											value={assignment}
											onChange={(e) =>
												setAssignment(e.target.value)
											}
											type="text"
											tabindex="3"
										/>
									</fieldset>{" "}
									<label>Test</label>
									<fieldset>
										<input
											placeholder="Test"
											type="text"
											tabindex="3"
											value={test}
											onChange={(e) =>
												setTest(e.target.value)
											}
										/>
									</fieldset>
									<label>Name</label>
									<fieldset>
										<input
											placeholder="Name"
											type="text"
											value={name}
											onChange={(e) =>
												setName(e.target.value)
											}
											tabindex="3"
											required
										/>
									</fieldset>
									<label>Description</label>
									<fieldset>
										<input
											placeholder="Description"
											type="text"
											tabindex="3"
											name="description"
											required
											value={description}
											onChange={(e) =>
												setDescription(e.target.value)
											}
										/>{" "}
									</fieldset>
									<button
										name="submit"
										type="submit"
										id="upload"
									>
										Upload
									</button>
								</form>
							</div>
						</FormDiv>
					</ClickAwayListener>
				</Backdrop>
			)}
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					padding: "20px, 0",
					height: "100vh",
				}}
			>
				<div style={{ marginTop: "50px" }}>
					{data.map((ele) => {
						return (
							<div>
								<Accordion
									title={ele.description}
									name={ele.name}
									content={ele.foundation}
									prodoc={ele.prodoc}
								/>
							</div>
						);
					})}
				</div>
				<div style={{ marginTop: "10px" }}>
					{" "}
					{/* <Link to={`/FormUploadContent/`}> */}
					<Button
						// style={buttonStyle}
						variant="contained"
						color="success"
						onClick={() => setDisplayForm(true)}
					>
						Upload Content
					</Button>
					{/* </Link> */}
				</div>
			</div>
		</div>
	);
};

export default ContentDetail;
